import Vue from "vue";
import Router from "vue-router";
import share from "@/components/share";
import download from "@/components/download";
import invite from "@/components/invite";
import sharePc from "@/components/sharePc";
import activity from "@/components/activity";
import privacy from "@/components/privacy";
import xmprivacy from "@/components/xmprivacy";
import hmprivacy from "@/components/hmprivacy";
import UrlScheme from "@/components/UrlScheme";
import report from "@/components/report";
import recycle from "@/components/recycle";
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

export default new Router({
  // mode: "history",
  routes: [
    {
      path: "/recycle",
      name: "recycle",
      component: recycle,
      meta: { title: "闲至回收 限时补贴" }
    },
    {
      path: "/share",
      name: "share",
      component: share
    },
    {
      path: "/sharePc",
      name: "sharePc",
      component: sharePc
    },
    {
      path: "/download",
      name: "download",
      component: download
    },
    {
      path: "/invite",
      name: "invite",
      component: invite
    },
    {
      path: "/activity",
      name: "activity",
      component: activity
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy
    },
    {
      path: "/xmprivacy",
      name: "xmprivacy",
      component: xmprivacy
    },
    {
      path: "/hmprivacy",
      name: "hmprivacy",
      component: hmprivacy,
      meta: { title: "隐私协议" }
    },
    {
      path: "/UrlScheme",
      name: "UrlScheme",
      component: UrlScheme,
    },
    {
      path: "/report",
      name: "report",
      component: report,
      meta: { title: "质检报告" }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js